import React from "react";
import { Button, Form, Table } from "react-bootstrap";
import BarsChart from "../../barschart/Barschart";
import { WarningIcon } from "../../../utility/icons/Icons";
import './budgetreporttab.css';

const Budgetreporttab: React.FC = () => {
    return (
        <>
            <div className="common_card mby_20">
                <div className="top top_bar_flx">
                    <div className="top_bar_tittle">
                        <h2>By Region — Billable • Billed • Paid</h2>
                    </div>
                    <div className="top_right_flx">
                        <Button variant="light" className="btn_sm">Export</Button>
                    </div>
                </div>

                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Region</th>
                            <th>Billable</th>
                            <th>Billed</th>
                            <th>Paid</th>
                            <th>Realization %</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Region 1</td>
                            <td>$10,000</td>
                            <td>$10,000</td>
                            <td>$10,000</td>
                            <td>93%</td>
                        </tr>
                        <tr>
                            <td>Region 2</td>
                            <td>$12,000</td>
                            <td>$12,000</td>
                            <td>$12,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 3</td>
                            <td>$15,000</td>
                            <td>$15,000</td>
                            <td>$15,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 4</td>
                            <td>$11,000</td>
                            <td>$11,000</td>
                            <td>$11,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 5</td>
                            <td>$14,000</td>
                            <td>$14,000</td>
                            <td>$14,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 6</td>
                            <td>$13,000</td>
                            <td>$13,000</td>
                            <td>$13,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 7</td>
                            <td>$16,000</td>
                            <td>$16,000</td>
                            <td>$16,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 8</td>
                            <td>$18,000</td>
                            <td>$18,000</td>
                            <td>$18,000</td>
                            <td>95%</td>
                        </tr>
                        <tr>
                            <td>Region 9</td>
                            <td>$20,000</td>
                            <td>$20,000</td>
                            <td>$20,000</td>
                            <td>95%</td>
                        </tr>
                    </tbody>
                </Table>


            </div>
            <div className="common_card mby_20">
                <div className="top top_bar_flx">
                    <div className="top_bar_tittle">
                        <h2>Region Breakdown</h2>
                    </div>
                    <div className="top_right_flx">
                        <Form.Select aria-label="Default select example" className="filled_white sm_input region_all">
                            <option>Region All</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </Form.Select>
                    </div>
                </div>
                <div className="gemittances_card_grid region_breakdown mby_20">
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Billable</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Billed</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Paid</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                </div>
                <BarsChart />
            </div>
            <div className="common_card mby_20">
                <div className="top top_bar_flx">
                    <div className="top_bar_tittle">
                        <h2>Budgets & Utilization</h2>
                    </div>
                    <div className="top_right_flx">
                        <h6 className="member_utilization_txt"><WarningIcon /> 1 member at 100% utilization</h6>
                    </div>
                </div>

                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Member</th>
                            <th>Auth Units</th>
                            <th>Used</th>
                            <th>Remaining</th>
                            <th>Days to Exhaustion</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>John D.</td>
                            <td>12</td>
                            <td>9</td>
                            <td>3</td>
                            <td>18</td>
                        </tr>
                        <tr>
                            <td>Sarah M.</td>
                            <td>10</td>
                            <td>10</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>Alex B.</td>
                            <td>8</td>
                            <td>5</td>
                            <td>3</td>
                            <td>24</td>
                        </tr>
                    </tbody>
                </Table>


            </div>

            <div className="common_card mby_20">
                <div className="top border_tittle top_bar_flx mby_16">
                    <div className="top_bar_tittle ">
                        <h2>Projected Growth (Paid)</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="caseloadGrowth">
                            <Form.Label>Caseload growth % / mo</Form.Label>
                            <Form.Select defaultValue="5">
                                <option>0</option>
                                <option>2</option>
                                <option>5</option>
                                <option>10</option>
                                <option>15</option>
                            </Form.Select>
                        </Form.Group>
                    </div>

                    <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="rateChange">
                            <Form.Label>Rate change % / mo</Form.Label>
                            <Form.Select defaultValue="0">
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>5</option>
                            </Form.Select>
                        </Form.Group>
                    </div>

                    <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                        <Form.Group className="custom_input_flled" controlId="utilization">
                            <Form.Label>Utilization realized %</Form.Label>
                            <Form.Select defaultValue="95">
                                <option>80</option>
                                <option>85</option>
                                <option>90</option>
                                <option>95</option>
                                <option>100</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                </div>
                <div className="gemittances_card_grid region_breakdown">
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Baseline (monthly)</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>Next Month</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                    <div className="gemittances_card_grid_items">
                        <div className="gemittances_card_txt">
                            <p>6 / 12 Months</p>
                            <h3>$123,456</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="common_card mby_20">
                <div className="top top_bar_flx mb-0">
                    <div className="top_bar_tittle">
                        <h2 className="mb-2">Billability Reconciliation — Waivera vs. PA Release (LaSRS) vs. Paid</h2>
                        <p>Generate and export 837P (SFTP/API to Gainwell/LMMIS) or printable CMS‑1500. Auto‑send enabled when connections are configured.</p>
                    </div>
                    <div className="top_right_flx flex-wrap">
                        <Button variant="primary" className="btn_sm">Create Batch</Button>
                        <Button variant="light" className="btn_sm">Export 837P</Button>
                        <Button variant="light" className="btn_sm">Print 1500</Button>
                    </div>
                </div>
            </div>

            <div className="common_card mby_20">
                <div className="top top_bar_flx mby_16">
                    <div className="top_bar_tittle">
                        <h2>Transmission Monitor (TA1 / 999 / 277CA)</h2>
                    </div>
                </div>

                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>File</th>
                            <th>TAI</th>
                            <th>999</th>
                            <th>277CA</th>
                            <th>Claims</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>837P_2025-09-01_0900.edi</td>
                            <td>Accepted</td>
                            <td>Accepted</td>
                            <td>Accepted</td>
                            <td>212</td>
                        </tr>
                        <tr>
                            <td>837P_2025-09-01_0900.edi</td>
                            <td>Accepted</td>
                            <td>Accepted</td>
                            <td>Accepted</td>
                            <td>205</td>
                        </tr>
                    </tbody>
                </Table>


            </div>
        </>
    );
};

export default Budgetreporttab;
